import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../../firebase";
import { Box, Card, CardContent, Typography, Button, Alert, Stack } from "@mui/material";

export default function Login() {
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/panel";

  const onLogin = async () => {
    setErr("");
    setBusy(true);
    try {
      const res = await signInWithPopup(auth, googleProvider);

      // Opcional (cliente): limitar a dominio UPV
      // OJO: esto NO sustituye reglas/roles en backend, pero mejora UX.
      const email = res.user?.email || "";
      // if (!email.endsWith("@upv.es")) {
      //   await auth.signOut();
      //   throw new Error("Acceso restringido: usa tu correo @upv.es");
      // }

      navigate(from, { replace: true });
    } catch (e) {
      setErr(e?.message || "Error al iniciar sesión");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", bgcolor: "#0b0f1a", px: 2 }}>
      <Card sx={{ width: 520, maxWidth: "100%", bgcolor: "rgba(255,255,255,0.06)", borderRadius: 4, border: "1px solid rgba(255,255,255,0.10)" }}>
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h5" sx={{ fontWeight: 800, color: "rgba(255,255,255,0.92)" }}>
            Acceso seguro al panel
          </Typography>

          <Typography sx={{ mt: 1, opacity: 0.85, color: "rgba(255,255,255,0.82)" }}>
            Autenticación con Google (Firebase). Si no estás autenticado, no podrás acceder a mapas, tablas y exportación.
          </Typography>

          <Stack spacing={1.5} sx={{ mt: 3 }}>
            <Button
              onClick={onLogin}
              variant="contained"
              disabled={busy}
              sx={{ textTransform: "none", borderRadius: 2, py: 1.2 }}
            >
              {busy ? "Conectando..." : "Entrar con Google"}
            </Button>

            <Button
              variant="text"
              sx={{ textTransform: "none", color: "rgba(255,255,255,0.8)" }}
              onClick={() => navigate("/", { replace: true })}
            >
              Volver a la landing
            </Button>

            <Alert severity="info" sx={{ bgcolor: "rgba(33,150,243,0.12)", color: "rgba(255,255,255,0.85)" }}>
              Recomendado: restringir acceso por rol/proyecto (admin/researcher/viewer) y registrar auditoría de accesos.
            </Alert>

            {err && (
              <Alert severity="error" sx={{ bgcolor: "rgba(244,67,54,0.12)", color: "rgba(255,255,255,0.9)" }}>
                {err}
              </Alert>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
